<template>
  <div id="app">
    <jt-header v-if="!notbanner"></jt-header>
    <div class="wrapper">
      <div class="content" id="contents">
        <router-view @isShowHeader="isShowHeader"></router-view>
        <CozeChat v-if="this.$root.COZEID" :type="isphone ? 'mobile' : 'pc'" />
      </div>
    </div>
    <jt-footer v-if="!notbanner"></jt-footer>
  </div>
</template>

<script>
import jtHeader from './components/header'
import jtFooter from './components/footer'
import CozeChat from './components/CozeChat'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'
import UserModel from './models/user'
import GameModel from './models/game'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW'
import locale from 'element-ui/lib/locale'

export default {
  name: 'app',
  components: {
    jtHeader,
    jtFooter,
    CozeChat,
  },

  data() {
    return {
      notbanner: true,
    }
  },

  async created() {
    const ua = window.navigator.userAgent.toLowerCase()
    const isphone = /android|webos|iphone|ipod|blackberry|ipad/i.test(ua)
    const iswechat = ua.match(/MicroMessenger/i) == 'micromessenger'
    let languageConfig = storage.getItem(constants.LANGUAGE)

    if (languageConfig) {
      const lang = {
        中文: 'zh',
        英文: 'en',
        中英文: 'enAndzh',
        繁体中文: 'cn',
      }
      this.$i18n.locale = lang[languageConfig]
      this.$i18n.fallbackLocale = lang[languageConfig]
      if (languageConfig == '中文'  || languageConfig == '中英文') {
        locale.use(zhLocale)
      } else if (languageConfig == '繁体中文') {
        locale.use(zhTWLocale)
      } else {
        locale.use(enLocale)
        document.body.style.fontFamily = 'Arial'
      }
    }

    let ico = storage.getItem(constants.ICO)
    if (ico) {
      const IconLink = document.createElement('link')
      IconLink.setAttribute('rel', 'shortcut icon')
      IconLink.setAttribute('type', 'image/x-icon')
      IconLink.setAttribute('href', ico)
      document.head.appendChild(IconLink)
    }

    let title = storage.getItem(constants.TITLE)
    if (title) {
      document.title = title
    }

    let router = this.$router

    let { current } = router.history
    if (
      current.path === '/' ||
      current.path === '/login.html' ||
      current.path === '/wxlogin.html'
    ) {
      this.$root.COZEID = ''
    } else if (storage.getItem('COZEID')) {
      this.$root.COZEID = storage.getItem('COZEID')
    }

    if (current.path === '/login1') {
      let { gid, tid } = current.query
      const data = await UserModel.login1({ gid, tid })
      if (data) {
        let { origin } = window.location
        window.location.href = `${origin}/login.html?token=${data}`
      } else {
        router.replace('/login.html')
      }
    }

    if (current.path === '/login.html') {
      let { token, oid } = current.query
      if (token) {
        const that = this
        let userInfo = { gameId: 1, username: 1, password: 1, token, that }
        try {
          const loginInfo = await UserModel.login(userInfo)
          const router = this.$router
          const cozeId = storage.getItem('COZEID')
          let lan = loginInfo.language
          storage.clear()
          storage.setItem(constants.GLOBAL_CONFIG, loginInfo)
          storage.setItem(constants.LOGO, 1)
          storage.setItem(constants.LANGUAGE, lan)
          storage.setItem('COZEID', cozeId)

          if (lan) {
            const lang = {
              中文: 'zh',
              英文: 'en',
              中英文: 'enAndzh',
              繁体中文: 'cn'
            }
            this.$i18n.locale = lang[lan]
            this.$i18n.fallbackLocale = lang[lan]
            if (lan == '中文' || lan == '中英文' ) {
              locale.use(zhLocale)
            } else if (lan == '繁体中文') {
              locale.use(zhTWLocale)
            } else {
              locale.use(enLocale)
              document.body.style.fontFamily = 'Arial'
            }
          }
          router.push(`/page/${loginInfo.pageInfo[0].pageId}`)
        } catch (error) {}
      } else if (oid) {
        storage.setItem('oid', oid)
      }
    }

    if (current.path === '/' || current.path === '/jointeam.html') {
      let { oid, nickname } = current.query
      if (oid && nickname) {
        let info = { oid, nickname }
        storage.setItem(constants.WX_INFO, info)
      }
    }

    if (storage.getItem(constants.WX_INFO)) {
      if (
        !storage.getItem(constants.GLOBAL_CONFIG) &&
        current.path !== '/jointeam.html'
      ) {
        this.$router.push('/wxlogin.html')
      }
    } else if (
      !storage.getItem(constants.GLOBAL_CONFIG) &&
      current.path !== '/signup.html' &&
      current.path !== '/forgetpassword.html' &&
      current.path !== '/changepassword.html' &&
      current.path !== '/updatepassword.html' &&
      current.path !== '/jointeam.html' &&
      current.path !== '/login1'
    ) {
      if (iswechat && !storage.getItem('oid')) {
        let { noOid } = current.query
        if (noOid) {
          this.$router.push('/login.html')
        } else {
          const data = await GameModel.getOid()
          let { redirectUrl } = data
          window.location.href = redirectUrl
        }
      } else {
        this.$router.push('/login.html')
      }
    }
  },

  mounted() {
    let router = this.$router
    let { current } = router.history
    if (current.path.indexOf('/page') > -1) {
      this.isShowHeader(1)
    } else if (
      current.path !== '/login.html' &&
      current.path !== '/wxlogin.html' &&
      current.path !== '/'
    ) {
      this.isShowHeader()
    }
  },

  methods: {
    isShowHeader(page) {
      let ele = document.getElementById('app')
      let ele1 = document.getElementById('contents')
      let bannerUrl = storage.getItem('bannerUrl')
      if (page || !bannerUrl) {
        ele.style.backgroundImage = 'none'
        ele.style.backgroundColor = '#ECECEC'
        ele1.style.backgroundColor = '#fff'
        ele1.style.height = 'calc(100vh - 144px)'
        this.notbanner = false
      } else {
        let url =
          window.innerWidth < 768 && bannerUrl.bannerm
            ? bannerUrl.bannerm
            : bannerUrl.banner

        ele.style.backgroundImage = `url(${url})`
        ele.style.backgroundColor = `#8cc63e`
        ele1.style.backgroundColor = 'unset'
        ele1.style.height = 'calc(100vh - 16px)'
        this.notbanner = true
      }
    },
  },

  watch: {
    $route(to, from) {
      if (to.path == '/') {
        if (from.path == '/login.html') {
          this.$router.push('/login.html')
        }
        if (from.path == '/wxlogin.html') {
          this.$router.push('/wxlogin.html')
        }
      }
      if (to.path.indexOf('/page') > -1) {
        this.isShowHeader(1)
      } else {
        this.isShowHeader()
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
#app {
  min-height: 100vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: auto;
  background-color: #ECECEC;

  .wrapper {
    padding: 8px;

    .content {
      background-color: #fff;
      height: calc(100vh - 112px);
      // max-height: calc(100vh - 8em);
      // overflow: auto;
    }
  }

  .aiicon {
    position: fixed;
    right: 20px;
    bottom: 50px;
    color: #f00;
    font-size: 40px;
  }
}
</style>
